export default __webpack_public_path__ + "static/media/image-work-team-m@3x.91d821f6.png";